<template>
  <sui-segment class="login-view" :loading="silentLoginLoading">
    <sui-message v-if="error" negative>
      {{ errorMessage }}
    </sui-message>
    <AuthButton ref="authButton" />
  </sui-segment>
</template>

<script>
export default {
  data: () => ({
    silentLoginLoading: false
  }),

  computed: {
    error() {
      return this.$route.query.error;
    },

    errorMessage() {
      return this.error === "access_denied"
        ? this.$t("auth.accessDenied")
        : this.$t("auth.loginFailed");
    }
  },

  mounted() {
    if (this.error) {
      return;
    }

    if (this.$route.query.auto) {
      this.$auth.startLogin().catch(() => {
        window.postMessage(
          {
            type: "auth.fail"
          },
          window.location.origin
        );
      });
    } else {
      this.$refs.authButton.onClick();

      // this.silentLoginLoading = true;
      // this.$auth.silentLogin()
      //     .then(() => {
      //         this.$router.replace(this.$route.query.from || '/customers');
      //     })
      //     .catch(console.error)
      //     .finally(() => {
      //         this.silentLoginLoading = false;
      //     });
    }
  }
};
</script>

<style>
.login-view {
  text-align: center;
}
</style>